import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material.module';

import { FooterComponent } from '@mp-shared/components/footer/footer.component';
import { HeaderComponent } from '@mp-shared/components/header/header.component';
import { ResourceCardComponent } from '@mp-shared/components/resource-card/resource-card.component';
import { FeedbackDialogComponent } from '@mp-shared/components/feedback-dialog/feedback-dialog.component';
import { RouterModule } from '@angular/router';
import { PrivacyComponent } from './components/privacy/privacy.component';
import { TermsComponent } from './components/terms/terms.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    ResourceCardComponent,
    FeedbackDialogComponent,
    PrivacyComponent,
    TermsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    FormsModule,
  ],
  exports: [
    MaterialModule,
    CommonModule,
    FormsModule,
    FooterComponent,
    HeaderComponent,
    ResourceCardComponent,
    FeedbackDialogComponent,
  ],
})
export class SharedModule {
}
